export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <i className="ri-windy-line text-3xl text-cyan-400"></i>
              <span className="text-2xl font-bold">合同会社ｌｕｃｅ</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              法人のお客様に寄り添い、事業運営に関する各種サポートを丁寧にご案内いたします。
            </p>
            <div className="space-y-2 text-gray-400">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-cyan-400"></i>
                東京都世田谷区松原２丁目２１番１０号ＢＥＳ明大前コート１０２
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">クイックリンク</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  ホーム
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  選ばれる理由
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  サービス
                </a>
              </li>
              <li>
                <a href="#flow" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  ご利用の流れ
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  会社概要
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  サービス案内
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  ご相談内容
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  対応領域
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; 2026 合同会社ｌｕｃｅ. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a 
                href="/privacy" 
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
